module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_tablet-88712d092ed6aae895fe2283495c09c9.webp";